import { render, staticRenderFns } from "./CheckoutModalAddressVerification.vue?vue&type=template&id=5e7aecc0&scoped=true&"
import script from "./CheckoutModalAddressVerification.vue?vue&type=script&lang=js&"
export * from "./CheckoutModalAddressVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7aecc0",
  null
  
)

export default component.exports